import { render, staticRenderFns } from "./tipodecodigoexame.vue?vue&type=template&id=83c81b50&"
import script from "./tipodecodigoexame.vue?vue&type=script&lang=js&"
export * from "./tipodecodigoexame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports